// extracted by mini-css-extract-plugin
export default {"savedLoadsList":"style_savedLoadsList__wXw3c","savedLoadEmptyList":"style_savedLoadEmptyList__0+APO","savedLoadEmptyTitle":"style_savedLoadEmptyTitle__ZjpeS"};